/* custom-cl-money — window.clMoney(cents, trim): a price in the shopper's currency and the page's language format.
   Twin of snippets/custom-cl-money.liquid (keep the EUR table identical). Bulgarian keeps today's format (€29,75).
   Shoppers paying in their local currency (EU market: CZK, DKK, HUF, PLN, RON, SEK) get Shopify's own format for that
   currency, read from a sample the layout renders onto this script tag (data-cur, data-sample = 123456 | money), so a
   repaint shows exactly what the server rendered: 871 zł, 783,90 zł, 2 245 kr, 73.200 Ft.
   clMoney(cents, trim, 'EUR') formats euros whatever the shopper pays in (the product page's currency toggle).
   window.clFromEur(cents): a euro-fixed amount (free-shipping threshold) in the shopper's currency, rounded up to a whole unit. */
(function () {
  if (window.clMoney) return;
  var me = document.currentScript;
  var CUR = (me && me.getAttribute('data-cur')) || 'EUR';
  var LF = parseSample((me && me.getAttribute('data-sample')) || '');
  var NB = '\u00a0';
  var T = { en: ['.', ',', 'pre'], nl: [',', '.', 'pre-space'], fr: [',', NB, 'post'], pl: [',', NB, 'post'], cs: [',', NB, 'post'],
    sk: [',', NB, 'post'], fi: [',', NB, 'post'], sv: [',', NB, 'post'], lv: [',', NB, 'post'], lt: [',', NB, 'post'], et: [',', NB, 'post'],
    hu: [',', NB, 'post'], pt: [',', NB, 'post'] };

  /* "1.234,56 zł" → prefix, suffix, thousands mark, decimal mark, decimals (0 when the currency shows none: "1.235 Ft") */
  function parseSample(s) {
    var i0 = s.search(/\d/), i1 = s.length - 1;
    if (i0 < 0) return null;
    while (i1 > i0 && !/\d/.test(s.charAt(i1))) i1--;
    var num = s.slice(i0, i1 + 1), dec = '', decimals = 0, intPart = num;
    if (/\D56$/.test(num)) { dec = num.charAt(num.length - 3); decimals = 2; intPart = num.slice(0, -3); }
    return { pre: s.slice(0, i0), post: s.slice(i1 + 1), th: intPart.replace(/\d/g, '').charAt(0), dec: dec, decimals: decimals };
  }
  function fmtLocal(c, neg, trim) {
    var whole, frac = '';
    if (!LF.decimals) whole = Math.round(c / 100);
    else { whole = Math.floor(c / 100); frac = ('0' + (c % 100)).slice(-2); if (trim && frac === '00') frac = ''; }
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, LF.th);
    return (neg ? '-' : '') + LF.pre + w + (frac ? LF.dec + frac : '') + LF.post;
  }

  window.clMoney = function (cents, trim, disp) {
    var c = Math.round(Number(cents) || 0), neg = c < 0;
    if (neg) c = -c;
    if ((disp || CUR) !== 'EUR' && LF) return fmtLocal(c, neg, trim);
    var lang = String(document.documentElement.lang || 'bg').toLowerCase().split('-')[0];
    var whole = Math.floor(c / 100), frac = ('0' + (c % 100)).slice(-2);
    if (lang === 'bg') {
      var s = whole + (trim && frac === '00' ? '' : ',' + frac);
      return (neg ? '−' : '') + '€' + s;
    }
    var t = T[lang] || [',', '.', 'post'];
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, t[1]);
    var n = (neg ? '−' : '') + w + (trim && frac === '00' ? '' : t[0] + frac);
    return t[2] === 'pre' ? '€' + n : t[2] === 'pre-space' ? '€' + NB + n : n + NB + '€';
  };
  window.clCurCode = CUR;
  window.clFromEur = function (eurCents) {
    if (CUR === 'EUR') return eurCents;
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return Math.ceil((eurCents * rate) / 100) * 100;
  };

  /* euro-fixed amounts the server could not convert: wrapped amounts in copy + the cart page's free-shipping line */
  function fx() {
    if (CUR === 'EUR') return;
    document.querySelectorAll('[data-cl-fx-eur]').forEach(function (el) {
      el.textContent = window.clMoney(window.clFromEur(parseInt(el.getAttribute('data-cl-fx-eur'), 10) || 0), true);
    });
    document.querySelectorAll('[data-cl-fx-ship]').forEach(function (box) {
      var thr = window.clFromEur(parseInt(box.getAttribute('data-eur-threshold'), 10) || 10000);
      var sub = parseInt(box.getAttribute('data-sub'), 10) || 0, rem = thr - sub;
      var amt = box.querySelector('[data-cl-fx-ship-amt]'), left = box.querySelector('[data-cl-fx-ship-left]');
      var done = box.querySelector('[data-cl-fx-ship-done]'), fill = box.querySelector('[data-cl-fx-ship-fill]');
      if (amt) amt.textContent = window.clMoney(Math.max(rem, 0));
      if (left) left.hidden = rem <= 0;
      if (done) done.hidden = rem > 0;
      if (fill) fill.style.width = Math.min(100, Math.round((sub / thr) * 100)) + '%';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fx); else fx();
})();
